var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 7.16344 7.16344 0 16 0H48C56.8366 0 64 7.16344 64 16V48C64 56.8366 56.8366 64 48 64H16C7.16344 64 0 56.8366 0 48V16Z",
    fill: "#EFF6FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13596_13154)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 29V26H38V29H35V31H38V34H40V31H43V29H40ZM29 32C31.21 32 33 30.21 33 28C33 25.79 31.21 24 29 24C26.79 24 25 25.79 25 28C25 30.21 26.79 32 29 32ZM29 26C30.1 26 31 26.9 31 28C31 29.1 30.1 30 29 30C27.9 30 27 29.1 27 28C27 26.9 27.9 26 29 26ZM35.39 34.56C33.71 33.7 31.53 33 29 33C26.47 33 24.29 33.7 22.61 34.56C21.61 35.07 21 36.1 21 37.22V40H37V37.22C37 36.1 36.39 35.07 35.39 34.56ZM35 38H23V37.22C23 36.84 23.2 36.5 23.52 36.34C24.71 35.73 26.63 35 29 35C31.37 35 33.29 35.73 34.48 36.34C34.8 36.5 35 36.84 35 37.22V38Z",
    fill: "#2F7EE9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13596_13154"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(20 20)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.e3b6ec008d296a7ac7238fe143c26afc.svg";
export { ForwardRef as ReactComponent };